import { UIHeading5 } from '@cian/ui-kit';

import styles from './ComparisonNotificationContainer.css';
import { FC, useState, useEffect, useCallback } from 'react';
import { ComparisonNotification } from '../../components/ComparisonNotification';
import { IComparisonNotification } from '../../types';

interface IComparisonNotificationContainerProps {
  notification: IComparisonNotification;
  onNotificationClear: VoidFunction;
}

const NOTIFICATION_EXPIRATION_DELAY = 15000;

export const ComparisonNotificationContainer: FC<IComparisonNotificationContainerProps> = ({
  notification,
  onNotificationClear,
}) => {
  const { text, url } = notification;
  const [timeoutId, setNotificationTimeout] = useState<ReturnType<typeof setTimeout> | null>(null);

  const clearNotification = useCallback(() => {
    setNotificationTimeout(setTimeout(onNotificationClear, NOTIFICATION_EXPIRATION_DELAY));
  }, [onNotificationClear]);

  useEffect(() => {
    clearNotification();

    return () => {
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
    };
  }, [notification]); // eslint-disable-line

  const handleMouseEnter = useCallback(() => {
    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }
  }, [timeoutId]);

  const control = url ? (
    <UIHeading5 color="text-inverted-default">
      <a href={url} className={styles['link']} onClick={clearNotification} target="_blank" rel="noreferrer">
        Перейти
      </a>
    </UIHeading5>
  ) : (
    <UIHeading5 color="text-inverted-default">
      <button onClick={clearNotification} className={styles['button']}>
        Понятно
      </button>
    </UIHeading5>
  );

  if (text.length === 0) {
    return null;
  }

  return <ComparisonNotification control={control} text={text} onMouseEnter={handleMouseEnter} />;
};
